export default __webpack_public_path__ + "static/media/Lapiz-edicion.6b48b534.svg";